import React from 'react'

import { Fieldset, Subsection } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import { TagSelect } from '../../../../components/TagSelect'
import { useTagsQuery } from '../../../../hooks/useTagsQuery'
import type { FormValues } from '../../types'
import { FormFields } from '../../types'

type Props = {
  disabled?: boolean
}

export const TagsFields = ({ disabled }: Props) => {
  const { tagsQuery } = useTagsQuery([{ limit: 9999 }])
  const { values, setFieldValue } = useFormikContext<FormValues>()

  const tags = tagsQuery.data?.tags.map((tag) => tag.name)

  const handleTagAdd = (tag: string) => {
    setFieldValue(FormFields.tags, [...values.tags, tag])
  }

  const handleTagRemove = (tag: string) => {
    setFieldValue(
      FormFields.tags,
      values.tags.filter((existingTag) => existingTag !== tag),
    )
  }

  return (
    <Subsection title="Tags">
      <Fieldset>
        <Fieldset.Row>
          <Fieldset.Item>
            Add tags that members can use to find posts they are interested in.
          </Fieldset.Item>
        </Fieldset.Row>
        <Fieldset.Row>
          <Fieldset.Item>
            <TagSelect
              selectedTags={values.tags}
              tags={tags || []}
              withAddButton
              disabled={disabled}
              onAdd={handleTagAdd}
              onRemove={handleTagRemove}
            />
          </Fieldset.Item>
        </Fieldset.Row>
      </Fieldset>
    </Subsection>
  )
}
